
import { useState } from 'react';
import { useStore } from './store';
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const SubmitButton = () => {
  const nodes = useStore((s) => s.nodes);
  const edges = useStore((s) => s.edges);
  const clearCanvas = useStore((s) => s.clearCanvas); 
  const [result, setResult]   = useState(null);  
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_URL}/pipelines/parse`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nodes, edges }),
      });
      if (!res.ok) throw new Error(`Server error: ${res.status}`);
      const data = await res.json();
      setResult(data);
    } catch (err) {
      setError(err.message || 'Could not reach backend. Is it running?');
    } finally {
      setLoading(false);
    }
  };

  // Styles 
  
  const barStyle = {
    padding: '16px 24px',
    background: '#ffffff', 
    borderTop: '1px solid #e2e8f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // <-- CHANGED THIS TO 'center'
    flexWrap: 'wrap', 
    gap: 16,
    boxShadow: '0 -1px 3px rgba(0,0,0,0.02)',
    fontFamily: '"Inter", "Segoe UI", sans-serif',
    zIndex: 10,
    position: 'relative'
  };

  const btnStyle = {
    padding: '10px 24px',
    borderRadius: 8,
    border: 'none',
    background: loading ? '#4f46e5' : '#6366f1',
    color: '#fff',
    fontWeight: 600,
    fontSize: 14,
    cursor: loading ? 'not-allowed' : 'pointer',
    transition: 'all 0.2s',
    boxShadow: '0 2px 4px rgba(99, 102, 241, 0.2)'
  };

  const clearBtnStyle = {
    padding: '10px 24px',
    borderRadius: 8,
    border: '1px solid #e2e8f0',
    background: '#ffffff',
    color: '#ef4444',
    fontWeight: 600,
    fontSize: 14,
    cursor: 'pointer',
    transition: 'all 0.2s',
  };


  const overlayStyle = {
    position: 'fixed', inset: 0,
    background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 9999,
  };

  const modalStyle = {
    background: '#fff',
    borderRadius: 14,
    padding: '28px 32px',
    minWidth: 320,
    boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
    fontFamily: '"Inter", "Segoe UI", sans-serif',
  };

  const statStyle = (color) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 14px',
    borderRadius: 8,
    background: color + '18',
    border: `1px solid ${color}33`,
    marginBottom: 10,
  });

  return (
    <>
      {/* Responsive Bottom Bar */}
      <div style={barStyle}>
               
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            style={clearBtnStyle}
            onClick={clearCanvas}
            onMouseEnter={e => { e.target.style.background = '#fef2f2'; e.target.style.borderColor = '#fecaca'; }}
            onMouseLeave={e => { e.target.style.background = '#ffffff'; e.target.style.borderColor = '#e2e8f0'; }}
          >
            Clear Canvas
          </button>

          <button
            style={btnStyle}
            onClick={handleSubmit}
            disabled={loading}
            onMouseEnter={e => !loading && (e.target.style.background = '#4f46e5')}
            onMouseLeave={e => !loading && (e.target.style.background = '#6366f1')}
          >
            {loading ? 'Analyzing…' : 'Submit Pipeline'}
          </button>
        </div>
      </div>

      {/* Error toast */}
      {error && (
        <div style={{
          position: 'fixed', bottom: 90, left: '50%', transform: 'translateX(-50%)',
          background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626',
          borderRadius: 8, padding: '10px 20px', fontSize: 13, zIndex: 9998,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        }}>
           {error}
          <button onClick={() => setError(null)}
            style={{ marginLeft: 12, background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontWeight: 700 }}>
            ✕
          </button>
        </div>
      )}

      {/* Result modal */}
      {result && (
        <div style={overlayStyle} onClick={() => setResult(null)}>
          <div style={modalStyle} onClick={e => e.stopPropagation()}>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#0f172a' }}>
                Pipeline Analysis
              </div>
              <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                Results from the backend
              </div>
            </div>

            <div style={statStyle('#6366f1')}>
              <span style={{ color: '#4338ca', fontWeight: 600 }}>Nodes</span>
              <span style={{ color: '#4338ca', fontWeight: 700, fontSize: 20 }}>
                {result.num_nodes}
              </span>
            </div>

            <div style={statStyle('#0ea5e9')}>
              <span style={{ color: '#0369a1', fontWeight: 600 }}>Edges</span>
              <span style={{ color: '#0369a1', fontWeight: 700, fontSize: 20 }}>
                {result.num_edges}
              </span>
            </div>

            <div style={statStyle(result.is_dag ? '#10b981' : '#ef4444')}>
              <div>
                <div style={{ fontWeight: 600, color: result.is_dag ? '#065f46' : '#991b1b' }}>
                  {result.is_dag ? '✓ Valid DAG' : '✗ Not a DAG'}
                </div>
                <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>
                  {result.is_dag
                    ? 'No cycles detected — pipeline can execute'
                    : 'Cycle detected — pipeline cannot execute'}
                </div>
              </div>
            </div>

            <button
              onClick={() => setResult(null)}
              style={{
                width: '100%', marginTop: 8, padding: '10px',
                background: '#f1f5f9', border: 'none', borderRadius: 7,
                color: '#475569', fontWeight: 600, fontSize: 13, cursor: 'pointer',
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};